"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIDashboardCustomizableSelectDynamicConfig = exports.isIDashboardCustomizableFreeTextConfig = exports.isIDashboardCustomizableSelectStaticConfig = exports.isIDashboardCustomizableConfig = exports.isIConfigContextValueArray = exports.isIConfigContextValue = exports.isNonEmptyObject = exports.isINonObjectConfigContextValues = exports.isICustomizableConfigDefinitionMultipleValues = exports.DEFAULT_CONTEXT = exports.SUPPORTED_CONFIGURATION_CONTEXTS = exports.SINGLE_CONFIG_KEY = exports.REMOVE_CONFIG_VALUE = exports.OptionsFetcher = exports.CustomizableConfigInputType = void 0;
const configuration_1 = require("../configuration");
var CustomizableConfigInputType;
(function (CustomizableConfigInputType) {
    CustomizableConfigInputType["SingleSelectStaticValues"] = "SingleSelectStaticValues";
    CustomizableConfigInputType["MultiSelectStaticValues"] = "MultiSelectStaticValues";
    CustomizableConfigInputType["MultiSelectDynamicValues"] = "MultiSelectDynamicValues";
    CustomizableConfigInputType["Number"] = "Number";
    CustomizableConfigInputType["String"] = "String";
    CustomizableConfigInputType["StringArray"] = "StringArray";
    CustomizableConfigInputType["NumberArray"] = "NumberArray";
    CustomizableConfigInputType["Date"] = "Date";
    CustomizableConfigInputType["Boolean"] = "Boolean";
    CustomizableConfigInputType["Object"] = "Object";
})(CustomizableConfigInputType = exports.CustomizableConfigInputType || (exports.CustomizableConfigInputType = {}));
const SELECT_INPUT_TYPES = [
    CustomizableConfigInputType.MultiSelectDynamicValues,
    CustomizableConfigInputType.SingleSelectStaticValues,
    CustomizableConfigInputType.MultiSelectStaticValues
];
const FREE_TEXT_INPUT_TYPES = Object.values(CustomizableConfigInputType)
    .filter(inputType => !SELECT_INPUT_TYPES.includes(inputType));
var OptionsFetcher;
(function (OptionsFetcher) {
    OptionsFetcher["CustomerStatuses"] = "CustomerStatuses";
})(OptionsFetcher = exports.OptionsFetcher || (exports.OptionsFetcher = {}));
exports.REMOVE_CONFIG_VALUE = "acumen-rm";
exports.SINGLE_CONFIG_KEY = "single";
exports.SUPPORTED_CONFIGURATION_CONTEXTS = [
    configuration_1.ConfigurationEntityType.CustomerDefault,
    configuration_1.ConfigurationEntityType.GitRepository,
    configuration_1.ConfigurationEntityType.Team,
    configuration_1.ConfigurationEntityType.DataContributor
];
exports.DEFAULT_CONTEXT = "DEFAULT";
// --------------------------------------- //
// ------------ Type guards -------------- //
// --------------------------------------- //
function isICustomizableConfigDefinitionMultipleValues(input) {
    return input
        && typeof input === "object"
        && input.configParams !== undefined
        && input.nullable !== undefined;
}
exports.isICustomizableConfigDefinitionMultipleValues = isICustomizableConfigDefinitionMultipleValues;
function isINonObjectConfigContextValues(input) {
    return input
        && typeof input === "object"
        && input[exports.SINGLE_CONFIG_KEY] !== undefined;
}
exports.isINonObjectConfigContextValues = isINonObjectConfigContextValues;
function isNonEmptyObject(val) {
    return typeof val === "object"
        && !Array.isArray(val)
        && !(Object.keys(val).length === 0);
}
exports.isNonEmptyObject = isNonEmptyObject;
function isIConfigContextValue(input) {
    return input
        && typeof input === "object"
        && input.id !== undefined
        && input.configs !== undefined
        && (isNonEmptyObject(input.configs)
            || input.configs === null)
        || input.configs === exports.REMOVE_CONFIG_VALUE;
}
exports.isIConfigContextValue = isIConfigContextValue;
function isIConfigContextValueArray(input) {
    return input
        && typeof input === "object"
        && Array.isArray(input)
        && input.every(element => isIConfigContextValue(element));
}
exports.isIConfigContextValueArray = isIConfigContextValueArray;
function isIDashboardCustomizableConfig(input) {
    return input
        && isNonEmptyObject(input)
        && input.name !== undefined
        && input.nullable !== undefined;
}
exports.isIDashboardCustomizableConfig = isIDashboardCustomizableConfig;
function isIDashboardCustomizableSelectStaticConfig(input) {
    return isIDashboardCustomizableConfig(input)
        && (input.inputType === CustomizableConfigInputType.MultiSelectStaticValues
            || input.inputType === CustomizableConfigInputType.SingleSelectStaticValues)
        && input.possibleValues
        && Array.isArray(input.possibleValues);
}
exports.isIDashboardCustomizableSelectStaticConfig = isIDashboardCustomizableSelectStaticConfig;
function isIDashboardCustomizableFreeTextConfig(input) {
    return isIDashboardCustomizableConfig(input)
        && FREE_TEXT_INPUT_TYPES.includes(input.inputType);
}
exports.isIDashboardCustomizableFreeTextConfig = isIDashboardCustomizableFreeTextConfig;
function isIDashboardCustomizableSelectDynamicConfig(input) {
    return isIDashboardCustomizableConfig(input)
        && input.inputType === CustomizableConfigInputType.MultiSelectDynamicValues
        && input.optionsFetcher
        && Object.values(OptionsFetcher).includes(input.optionsFetcher);
}
exports.isIDashboardCustomizableSelectDynamicConfig = isIDashboardCustomizableSelectDynamicConfig;
//# sourceMappingURL=types.js.map